<template>
  <stzh-header :hide-metabar="hideMetabar" :sticky="sticky" class="stzh-header">
    <img slot="logo" src="https://www.stadt-zuerich.ch/content/dam/corporate-design/de/logos/stadt-zuerich.svg" alt="Logo City Zürich, go to homepage">
  </stzh-header>
</template>
<script>

export default {
  name: 'StzhUnprotectedViewHeader',
  props: {
    hideMetabar: {
      type: Boolean,
      default: true,
    },
    sticky: {
      type: String,
      default: 'disabled',
    },
  },
};
</script>

<style lang="scss" scoped>
  .stzh-header {
    position: relative;
    z-index: 601 !important; //stzh-dropdown popover is 600
  }
</style>
